import { useContext, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { MenuContext } from '../../context/menu';
import { apiConnections } from '../../services/api/connections';
import { TMenuDataResponse } from '../../types/api/responses';
import { useApiFetch } from './useApiFetch';
import { setYandexMapToken } from '../../redux/actions/yandex';

export const useMenu = () => {
    const action = useRef<TMenuDataResponse['action']>();
    const api = useApiFetch();
    const menuContext = useContext(MenuContext);
    const dispatch = useDispatch();

    const { menuData: conn } = apiConnections;

    /**
     * Загрузить список меню
     */
    const getMenuData = async () => {
        menuContext.loading.setter(true);

        const result = await api.fetchData<TMenuDataResponse>(conn.url, conn.method, conn.useToken);

        if (result.success && result.data && Array.isArray(result.data.elements)) {
            action.current = result.data.action;
            menuContext.data.setter(result.data.elements);
            if (typeof result.data.yandexMapToken === 'string') {
                dispatch(setYandexMapToken(result.data.yandexMapToken));
            }
        }

        menuContext.loading.setter(false);
    };

    return {
        action: action.current,
        getMenuData,
        loading: menuContext.loading.value,
        menuData: menuContext.data.value,
    };
};
